import React, { memo } from 'react';
import { Button, Modal } from 'rsuite';
import ModalFooter from 'rsuite/lib/Modal/ModalFooter';
import { useCurrentRoom } from '../../../context/current-room.context';
import { useModalState } from '../../../misc/custom-hooks';

function RoomInfoBtnModal() {
  const { isOpen, open, close } = useModalState();
  const description = useCurrentRoom(v => v.description);
  const name = useCurrentRoom(v => v.name);

  return (
    <>
      <Button appearance="link" className="px-0" onClick={open}>
        Room Information
      </Button>
      <Modal show={isOpen} onHide={close}>
        <Modal.Header>
          <Modal.Title>About {name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 className="mb-1">Description</h6>
          <p>{description}</p>
        </Modal.Body>
        <ModalFooter>
          <Button block onClick={close}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default memo(RoomInfoBtnModal);
